/**
 * Constantes e Enums para Templates e Filtros do WATI WhatsApp
 * Grupo Emops / SCORPIO ERP
 */

export const WATI_TEMPLATE_MODULOS = Object.freeze({
  CONFIRMACAO: "os_confirmacao",
  POS_VENDA: "pos_venda",
  COBRANCA: "cobranca",
  NPS: "nps",
  GERAL: "geral"
});

export const WATI_TEMPLATE_FILTROS = Object.freeze({
  [WATI_TEMPLATE_MODULOS.CONFIRMACAO]: ["confirmacao", "pco"],
  [WATI_TEMPLATE_MODULOS.POS_VENDA]: ["pos_venda", "pos-venda", "posvenda"],
  [WATI_TEMPLATE_MODULOS.COBRANCA]: ["cobranca", "cobranca_geral"],
  [WATI_TEMPLATE_MODULOS.NPS]: ["nps", "pesquisa", "satisfacao"]
});

/**
 * Retorna as palavras-chave para filtragem do WATI conforme o tipo do módulo
 * @param {string} tipo
 * @returns {string[]}
 */
export function getWatiTemplateFiltros(tipo) {
  if (!tipo) return [];
  const tipoLower = String(tipo).toLowerCase();

  if (tipoLower.includes("confirmacao") || tipoLower.includes("os_confirmacao") || tipoLower.includes("pco")) {
    return WATI_TEMPLATE_FILTROS[WATI_TEMPLATE_MODULOS.CONFIRMACAO];
  }
  if (tipoLower.includes("pos_venda") || tipoLower.includes("pos-venda") || tipoLower.includes("posvenda")) {
    return WATI_TEMPLATE_FILTROS[WATI_TEMPLATE_MODULOS.POS_VENDA];
  }
  if (tipoLower.includes("cobranca")) {
    return WATI_TEMPLATE_FILTROS[WATI_TEMPLATE_MODULOS.COBRANCA];
  }
  if (tipoLower.includes("nps")) {
    return WATI_TEMPLATE_FILTROS[WATI_TEMPLATE_MODULOS.NPS];
  }

  return [];
}

/**
 * Constrói a URL para a requisição de templates no backend
 * @param {string} tipo
 * @returns {string}
 */
export function buildGetWatiTemplatesUrl(tipo) {
  let url = "getWatiTemplates?filtro[status][]=approved";
  if (tipo) {
    url += "&filtro[tipo]=" + encodeURIComponent(tipo);
  }
  const palavras = getWatiTemplateFiltros(tipo);

  if (Array.isArray(palavras) && palavras.length > 0) {
    for (const palavra of palavras) {
      url += "&filtro[nomes][]=" + encodeURIComponent(palavra);
    }
  }

  return url;
}
